module.exports = __webpack_public_path__ + "img/active-15.e54aad4e.svg";